/*! @pentacode/ui v0.1.0 */
import { html as e } from "lit";
// src/elements/form-elements/input-label.ts
function t(t) {
	return e`<label class="block p-2 text-sm font-bold text-gray-700">${t}</label>`;
}
export { t as InputLabel };

//# sourceMappingURL=input-label.js.map